import axios from "axios";

const getMenuItems = async () => {
  return await axios.get("/menu");
};

const getCategoriesById = async (id) => {
  return await axios.get("/menu/" + id);
};

const getLabelsById = async (id) => {
  return await axios.get("/category/" + id);
};

export { getMenuItems, getCategoriesById, getLabelsById };
